export const categories = [
  { id: 1, name: '文本写作', icon: 'fa-pencil', tool_count: 120 },
  { id: 2, name: '图像生成', icon: 'fa-image', tool_count: 85 },
  { id: 3, name: '代码助手', icon: 'fa-code', tool_count: 64 },
  { id: 4, name: '音频处理', icon: 'fa-microphone', tool_count: 42 },
  { id: 5, name: '视频创作', icon: 'fa-video-camera', tool_count: 38 },
  { id: 6, name: '办公效率', icon: 'fa-briefcase', tool_count: 95 },
  { id: 7, name: '学习教育', icon: 'fa-graduation-cap', tool_count: 76 },
  { id: 8, name: '生活助手', icon: 'fa-coffee', tool_count: 53 }
];

export const tools = [
  {
    id: 1,
    name: 'AI 写作助手',
    description: '智能生成文章、邮件和营销文案，提升写作效率。支持多种风格和语调，让您的文字更具感染力。',
    thumbnail: 'https://picsum.photos/id/1/300/200',
    category_id: 1,
    creator_id: 1,
    download_count: 1250,
    rating: 4.8,
    created_at: '2023-10-15'
  },
  {
    id: 2,
    name: '梦幻画板',
    description: '输入文字即可生成精美画作，释放您的创意潜能。支持多种艺术风格，从油画到赛博朋克应有尽有。',
    thumbnail: 'https://picsum.photos/id/10/300/200',
    category_id: 2,
    creator_id: 2,
    download_count: 980,
    rating: 4.7,
    created_at: '2023-10-20'
  },
  {
    id: 3,
    name: '代码补全大师',
    description: '智能分析代码上下文，提供精准的代码补全建议。支持多种编程语言，让编程变得更加轻松愉快。',
    thumbnail: 'https://picsum.photos/id/20/300/200',
    category_id: 3,
    creator_id: 1,
    download_count: 850,
    rating: 4.9,
    created_at: '2023-11-05'
  },
  {
    id: 4,
    name: '语音转文字 Pro',
    description: '高精度语音识别，快速将会议录音转换为文字稿。支持多语种识别，是您工作会议的得力助手。',
    thumbnail: 'https://picsum.photos/id/30/300/200',
    category_id: 4,
    creator_id: 3,
    download_count: 720,
    rating: 4.6,
    created_at: '2023-11-12'
  },
  {
    id: 5,
    name: '视频剪辑魔法',
    description: 'AI 智能剪辑视频，自动生成精彩片段和字幕。即使是视频剪辑小白，也能轻松制作出大片感的视频。',
    thumbnail: 'https://picsum.photos/id/40/300/200',
    category_id: 5,
    creator_id: 2,
    download_count: 650,
    rating: 4.5,
    created_at: '2023-11-18'
  },
  {
    id: 6,
    name: '智能日程管理',
    description: '根据您的习惯智能安排日程，提醒重要事项。让您的生活和工作井井有条，不再错过任何重要时刻。',
    thumbnail: 'https://picsum.photos/id/50/300/200',
    category_id: 6,
    creator_id: 3,
    download_count: 580,
    rating: 4.4,
    created_at: '2023-11-25'
  }
];

export const users = [
  {
    id: 1,
    username: 'TechMaster',
    avatar: 'https://picsum.photos/id/64/40/40',
    points: 120
  },
  {
    id: 2,
    username: 'CreativeSoul',
    avatar: 'https://picsum.photos/id/65/40/40',
    points: 85
  },
  {
    id: 3,
    username: 'ProductivityPro',
    avatar: 'https://picsum.photos/id/66/40/40',
    points: 92
  }
];

export const rankings = [
  {
    period: 'weekly',
    tools: tools.slice(0, 5).sort((a, b) => b.download_count - a.download_count)
  },
  {
    period: 'monthly',
    tools: tools.slice(0, 5).sort((a, b) => b.rating - a.rating)
  }
];
